module.exports = __webpack_public_path__ + "img/caipirinha.869438a3.jpg";